import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';
import GoogleAnalytics from '../../../util/Ga.js';

// ES6 classNameName-style
class FounderVideos extends PreLoginSessionCheck {

	constructor () {
		super()
		this.state = {
		  isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.goNext = this.goNext.bind(this)
    	this.goPrev = this.goPrev.bind(this)
	}

	openModal (someValue) {
	    this.setState({isOpen: true})
	    this.videoId = someValue
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}

  render() {
  	const videoId = '';
  	const params = {
		slidesPerView: 3,
	 	spaceBetween: 30,
	 	loop: true,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    containerClass:'student-slider swiper-container',
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    }
		}
    }


  	return(
		<section className="our-student outer-padding">
			<div className="">
				<div className="container"> 
				<h4>Working at HeyMath!</h4> 
					<Swiper className="student-slider" breakpoints={params.breakpoints}  loop={params.loop}  slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween} containerClass={params.containerClass} ref={node => {if(node) this.swiper = node.swiper} }>

							{/* <div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Matthew Smith 1" onClick={this.openModal.bind(null,'RuUp6uVwY8w')} className="img-box popup-youtube">
 									<img src="../img/culture1.jpg" alt="Work culture at Heymath by Matthew Smith, Cambridge Education Consultant"/>
 									<span className="play-btn"></span>
	 							</div>
							</div> */}
							<div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Kyle Lomer " onClick={this.openModal.bind(null,'aP7yJHCFaWw')} className="img-box popup-youtube">
 									<img src="../img/culture2.jpg" alt="Cambridge Education Consultant Kyle Lomer shares his experience on Heymath"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>
							<div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Krishna Balakrishnan" onClick={this.openModal.bind(null,'j5TyBFhXzS0')} className="img-box popup-youtube">
 									<img src="../img/day-4.jpg" alt="NID Bengaluru Design Intern Student shares her Heymath Journey"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>							
							{/* <div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Matthew Smith 2" onClick={this.openModal.bind(null,'NN39lhbbu1U')} className="img-box popup-youtube">
 									<img src="../img/culture1.jpg" alt="Work culture at Heymath by Matthew Smith, Cambridge Education Consultant"/>
 									<span className="play-btn"></span>
	 							</div>
							</div> */}
							<div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Samuel Hewitt" onClick={this.openModal.bind(null,'nmvQOGbNEtQ')} className="img-box popup-youtube">
 									<img src="../img/day-3.jpg" alt="Cambridge Education Consultant Samuel Hewitt shares his journey on Heymath"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>
							{/* <div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Matthew Smith 3" onClick={this.openModal.bind(null,'8vZ4t0nmNyc')} className="img-box popup-youtube">
 									<img src="../img/day-2.jpg" alt="Work culture at Heymath by Matthew Smith, Cambridge Education Consultant"/>
 									<span className="play-btn"></span>
	 							</div>
							</div> */}
							<div className="swiper-slide">
								<div data-ga="Who we are - Our DNA and Culture- Kyle Lomer 2" onClick={this.openModal.bind(null,'MqP7N8T650U')} className="img-box popup-youtube">
 									<img src="../img/day-1.jpg" alt="Cambridge Education Consultant Kyle Lomer shares his experience on Heymath"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>
							
							{/* Star students  */}

							<div className="swiper-slide">
								<div data-ga="Home - Star Students - Shreyas Kumar" onClick={this.openModal.bind(null,'bRE5tit8zqU')} className="img-box popup-youtube">
								<img src="../img/student4.png" alt="Shreyas Kumar, Heymath Intern from Harvey Mudd shares his journey experience"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>

							<div className="swiper-slide">
								<div data-ga="Home - Star Students - Uday Saharia" onClick={this.openModal.bind(null,'KT-uJDOLOvA')} className="img-box popup-youtube">
								<img src="../img/student5.png" alt="Uday Saharia, Heymath Intern from University of Chicago presents his experience"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>

							<div className="swiper-slide">
								<div data-ga="Home - Star Students - Varun Ranganathan" onClick={this.openModal.bind(null,'MLyYoLco1eY')} className="img-box popup-youtube">
								<img src="../img/student6.png" alt="Varun Ranganathan, Heymath User and Intern from SSN College shares his experience"/>
 									<span className="play-btn"></span>
	 							</div>
							</div>

					</Swiper> 
					<div className="slider-btns">
		        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
		        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
	        		</div>
				</div>
			</div>
			<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
		</section>
  		);
  	}
}

export default FounderVideos; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/FounderVideos.js